import * as ngCore from '@angular/core'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as dms from '../dms'
import * as me from '../me'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Feature for managing mosaic variables
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    const _router = ngCore.inject(router.Router)
    const _schemaFeature = ngCore.inject(dms.schema.Feature)
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Variables',
      selectors: () => new Selectors(this, _router, _schemaFeature),
    })

    const meFeature = ngCore.inject(me.Feature)
    this.registerEffects(
      effects.removeFocusedAfterApply(),
      effects.putVariableDefinitionsForSelectedApp(meFeature),
    )
  }
}
